export const modalMakeProductActiveWidth = 1200;

export const modalIXOneCaptureWidth = 1200;
export const modalIXOneCaptureMinHeight = '56vh';

export const modalBodyProductActiveHeight = {
  height: 590,
  maxHeight: 600,
};

export const IXONE_HIERARCHY_LEVEL = {
  DISPLAY_SHIPPER: {
    NAME: 'Display Shipper',
    KEY: 'displayShipper',
    INDEX: 0, //* equal with Case
  },
  CASE: {
    NAME: 'Case',
    KEY: 'case',
    INDEX: 0,
  },
  INNERPACK: {
    NAME: 'Inner Pack',
    KEY: 'innerPack',
    INDEX: 1,
  },
  UNIT: {
    NAME: 'Unit',
    KEY: 'unit',
    INDEX: 2,
  },
};

export const IXONE_INIT_ADDING_HIERARCHY_LEVELS = [
  {
    index: 0,
    key: IXONE_HIERARCHY_LEVEL.CASE.KEY,
    packageLevel: IXONE_HIERARCHY_LEVEL.CASE.NAME,
    productItemId: null,
    parentProductItemId: null,
    equalWith: ['case', 'displayShipper'],
  },
  {
    index: 1,
    key: IXONE_HIERARCHY_LEVEL.INNERPACK.KEY,
    packageLevel: IXONE_HIERARCHY_LEVEL.INNERPACK.NAME,
    productItemId: null,
    parentProductItemId: null,
  },
  {
    index: 2,
    key: IXONE_HIERARCHY_LEVEL.UNIT.KEY,
    packageLevel: IXONE_HIERARCHY_LEVEL.UNIT.NAME,
    productItemId: null,
    parentProductItemId: null,
  },
];
